// extracted by mini-css-extract-plugin
export default {"title-header":"TitleHeader_title-header__KNgvE","titleHeader":"TitleHeader_title-header__KNgvE","row":"TitleHeader_row__LQSqj"};